import {AnswerValue} from './answer-value';
import {BooleanAnswerValue} from './boolean-answer-value';

export class ListAnswerValue extends BooleanAnswerValue {
  constructor (public label : string, public checked : boolean, public text : string) {
    super(label, checked);
  }
  copy() : AnswerValue {
    return new ListAnswerValue(this.label, this.checked, this.text);
  }

  isValid() : boolean {
    return super.isValid() && this.text && this.text.length > 0;
  }

  equals(other : ListAnswerValue) : boolean {
    return super.equals(other) && this.text == other.text;
  }

}



// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/model/list-answer-value.ts